<template lang="pug">
  tr(:active="data.selected")
    td.fixed(data-cy="checkbox-column")
      v-checkbox(
        color='primary'
        data-cy="data.selected"
        @click.native='selectOne'
        v-model='data.selected'
        hide-details
        primary
        )
    template(v-for='(value, key) in item')
      template(v-if='notEqual(key)')
        td.text-xs-left(:key='key')
          component(
            :is='dataCellComponent(key)'
            :data='item'
            :dataKey='key'
            @openActiveContactsList="openActiveContactsList(data)"
          )
    td.text-xs-right.actions(data-cy="data-table-actions")
      // hide actions if it is shared by the admin
      v-tooltip(top)
        template(slot="activator")
          v-btn(data-cy="stop" icon v-show='isItemStoppable(item)' @click="stop(item.id)")
            v-icon stop_circle
        span Cancel Campaign
      v-btn(data-cy="edit" icon v-show='shouldShowEditBtn(item)' @click="edit(item.id)")
        v-icon edit
      v-btn(data-cy="clone" v-show='isItemClonable(item)' icon @click="clone(item.id)")
        v-icon $vuetify.icons.clone
      v-btn(data-cy="remove" icon v-show='isItemEditable(item)' @click="remove(item.id)")
        v-icon delete
      v-menu.more--menu(
        v-show='isItemEditable(item) && isCampaignList'
        offset-y
        left
        max-height='300'
        data-cy="more"
      )
        v-btn.options(icon, slot='activator')
          v-icon more_vert
        v-list
          v-list-tile(v-if="!item.id_drip_shared" @click="publish(item.id)")
            v-list-tile-title
              span Publish Campaign for LionDesk Users
          v-list-tile(v-if="item.id_drip_shared" @click="editPublished()")
            v-list-tile-title
              span Edit Published Campaign
          v-list-tile(v-if="item.id_drip_shared" @click="unpublish()")
            v-list-tile-title
              span Unpublish Campaign
          v-list-tile(v-if="!item.is_broker_sharing_on && isAdmin" @click="share(item.id)")
            v-list-tile-title
              span Share with Sub-Accounts
          v-list-tile(v-if="item.is_broker_sharing_on && isAdmin" @click="unshare(item.id)")
            v-list-tile-title
              span Remove Sub-Account Sharing
    //- slot(name="actionMenu")
    //-   td(v-if='useDataTable')
    //-     data-table-menu(
    //-       offset-y
    //-       :data='data'
    //-       :actions='filteredActions'
    //-       icon='more_vert'
    //-       )
</template>

<script>
import DataTableMenu from '@/Core/components/DataTableMenu';
import Contacts from './CampaignsContacts';
import Name from './CampaignsName';
import ActionType from './CampaignActionType';
import Notes from './CampaignsNotes';
import TeamMember from './CampaignsTeamMember';
import Status from './CampaignsStatus';
import DateField from './CampaignsDate';
import Schedule from './CampaignsSchedule';
import StopOnTextReply from './CampaignsStopOnTextReply';
import Subject from './CampaignActionSubject';
import ActiveContacts from './ActiveContacts';

const TEXT_CONTACT_TYPE = 'Text Contact';

export default {
  components: {
    Contacts,
    Name,
    TeamMember,
    ActionType,
    Notes,
    Status,
    DateField,
    Schedule,
    DataTableMenu,
    Subject,
    ActiveContacts,
  },
  props: {
    useDataTable: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
    },
    actions: {
      type: Array,
    },
    selected: {
      type: Array,
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isCampaignList: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    hasBulkTexts: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    filteredActions() {
      if (this.data.item && this.data.item.is_shared_by_broker) {
        return [
          {
            title: 'See Actions',
            icon: 'event',
            pathName: 'campaigns-show',
            name: this.data.item.name || '',
            id: this.data.item.id,
          },
          {
            title: 'Clone',
            icon: 'file_copy',
            pathName: '',
          },
        ];
      }
      return this.actions;
    },
    item() {
      if (this.data.item) {
        return this.data.item;
      }
    },
    isTextAction() {
      if (!this.item) return false;
      return this.item.type === TEXT_CONTACT_TYPE;
    },
  },
  methods: {
    // keys that are needed, made visible so they're included but should not be rendered
    // on the actual table. This is a workaround for now.
    notEqual(key) {
      return !['id', 'is_shared_by_broker', 'is_broker_sharing_on', 'id_drip_shared'].includes(key);
    },
    isItemEditable(data) {
      return data.is_shared_by_broker != null ? !data.is_shared_by_broker : this.isEditable;
    },
    isItemClonable(data) {
      return data.is_shared_by_broker != null && !data.is_shared_by_broker;
    },
    isItemStoppable(data) {
      return data.contacts_with_pending_tasks > 0;
    },
    shouldShowEditBtn(item) {
      return (!this.isTextAction || this.hasBulkTexts) && this.isItemEditable(item);
    },
    selectOne(data) {
      this.$emit('click:select-one', data);
    },
    edit(data) {
      this.$emit('click:edit', data);
    },
    clone(data) {
      this.$emit('click:clone', data);
    },
    remove(data) {
      this.$emit('click:remove', data);
    },
    publish(data) {
      this.$emit('click:publish', data);
    },
    unpublish(data) {
      this.$emit('click:unpublish');
    },
    editPublished() {
      this.$emit('click:edit-published');
    },
    share(data) {
      this.$emit('click:share', data);
    },
    unshare(data) {
      this.$emit('click:unshare', data);
    },
    stop(data) {
      this.$emit('click:stop', data);
    },
    openActiveContactsList(data) {
      this.$emit('openActiveContactsList', data);
    },
    /**
     * Checks the column name and renders a component based on that
     * @param  {String} column the column name in the data object
     * @return {}              a vue component
     */
    dataCellComponent(column) {
      switch (column) {
        case 'name':
          return Name;
        case 'assigned_user':
          return TeamMember;
        case 'type':
          return ActionType;
        case 'status':
          return Status;
        case 'schedule':
          return Schedule;
        case 'created_at':
          return DateField;
        case 'modified_at':
          return DateField;
        case 'contacts':
          return Contacts;
        case 'is_stopped_on_text_reply':
          return StopOnTextReply;
        case 'template_subject':
          return Subject;
        case 'pending_contacts':
        case 'contacts_with_pending_tasks':
          return ActiveContacts;
        default:
          return Notes;
      }
    },
  },
};
</script>
